/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectionManagementWizard/services"/>
import {get, post} from "Core/Medius.Core.Web/Scripts/Medius/core/fetch/rest";

import { CompanyConfiguration, DefaultSupplierEmail, IEligibleForEmailCommunication, IEmailContent, IEmailSettings, IRejectionAction, IReasonCode, ISupplierInvoiceRejectionDto, RejectionEmailContentRequestDto } from "./interfaces";
import { postMultipart } from "Core/Medius.Core.Web/Scripts/Medius/core/communication/platform";

export function getActiveRejectionManagementReasonCodes(hierarchyId: string):Promise<Array<IReasonCode>> {
    return get(`remedium-api/apa/rejectionManagement/activeReasonCodes?hierarchyId=${encodeURIComponent(hierarchyId)}`);
}

export async function getEmailEligibility(documentId: number): Promise<IEligibleForEmailCommunication | null> {
    return get(`remedium-api/apa/rejectionManagement/emailEligibility?documentId=${documentId}`);
}

export async function postISupplierInvoiceRejectionDto(reasonCode: ISupplierInvoiceRejectionDto, attachments?: File[]): Promise<number> {
    const formData = new FormData();
    formData.append('Payload', JSON.stringify(reasonCode));
    
    if (attachments && attachments.length > 0) {
        attachments.forEach(file => {
            formData.append('Attachments', file);
        });
    }
    
    return postMultipart("remedium-api/apa/rejectionManagement/reject", formData);
}

export async function getEmailSettings(documentId: number): Promise<IEmailSettings> {
    return get(`remedium-api/apa/rejectionManagement/emailSettings/${documentId}`);
}

export async function getActiveRejectionActions(hierarchyId: string): Promise<IRejectionAction[]> {
    return get(`remedium-api/apa/rejectionAction/activeActions?hierarchyId=${encodeURIComponent(hierarchyId)}`);
}

export async function getCompanyConfiguration(companyId: number): Promise<CompanyConfiguration> {
    return get(`remedium-api/apa/rejectionManagement/companyConfiguration/${companyId}`);
}

export async function getSelectedReasonCodes(documentId: number): Promise<Array<IReasonCode>> {
    return get(`remedium-api/apa/rejectionManagement/invoices/${documentId}/rejection-reasons`);
}

export async function getRejectionEmailAiContent( documentId: number, rejectionEmailContentRequestDto: RejectionEmailContentRequestDto ): Promise<IEmailContent> {
    return post(`remedium-api/apa/rejectionManagement/rejectionEmail/${documentId}`, rejectionEmailContentRequestDto);
}

export async function getDefaultSupplierEmail( documentId: number): Promise<DefaultSupplierEmail> {
    return get(`remedium-api/apa/rejectionManagement/supplier/defaultEmail/${documentId}`);
}